import Grid from "../Grid";
import GridItem from "../GridItem";
import {br, cl, fx} from '../theme';
import cx from '../../../app/editor/utils/makeCls';
import Button from "../Button";

export default function FileField({
                                      className, value, label, btnLabel, size = 'm', accept = 'image',
                                      placeholder, onChange, onOpen,
                                  }) {
    const valFilename = value.replace(/^"|"$/ig, '').split('/').pop()?.split('?')[0] || '';
    const bgStyle = {backgroundImage: `url(${value})`};

    return (
        <div className={cx(className)}>
            {!!label && <label>{label}</label>}
            <Grid className={cx(cl.bg)} items="center" space="s" nowrap>
                <GridItem>
                    <div className={cx('w-[50px] h-[50px] bg-cover bg-checker', br.b, br.rnd, cl.br)}
                         style={bgStyle}></div>
                </GridItem>
                <GridItem grow className="overflow-hidden">
                    <div className={cx("mb-2", fx.txtEllips)}>{valFilename}</div>
                    <Button className="block" onClick={() => onOpen?.(value)} full>
                        {btnLabel || 'Select image'}
                    </Button>
                </GridItem>
            </Grid>
        </div>
    );
}